import * as React from 'react';
import { Modal } from '@cian/ui-kit';
import { FormModal } from 'shared/components/Modals';
import { useFormProps } from '../hooks/useFormProps';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsModalOpen, selectModalSource } from '../../../selectors/page';
import { setModalFormClose } from '../../../slices/pageSlice';
import { trackFormOpen } from '../tracking';

export const AgentModal: React.FC = () => {
  const isModalOpen = useSelector(selectIsModalOpen);
  const source = useSelector(selectModalSource);
  const prevModalOpenRef = React.useRef(false);

  const props = useFormProps();

  const dispatch = useDispatch();

  React.useEffect(() => {
    const justOpened = isModalOpen && !prevModalOpenRef.current;
    prevModalOpenRef.current = isModalOpen;
    if (justOpened) {
      trackFormOpen(source);
    }
  }, [isModalOpen, source]);

  const handleModalCloseClick = React.useCallback(() => {
    dispatch(setModalFormClose());
  }, [dispatch]);

  return (
    <Modal header={<div />} open={isModalOpen} onOpenChange={handleModalCloseClick} size="S">
      <FormModal {...props} />;
    </Modal>
  );
};
